import React, { useState, useEffect, useContext } from "react"
import axios from 'axios'
import DataTable from 'react-data-table-component';
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"

import PartidasPrint from "./PartidasPrint";
import RemisionPartidas from "./RemisionPartidas"
import { NumeroALetras } from "./PriceToText"
import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Modal from 'react-bootstrap/Modal'

import laJornada from './img/logo.png'

import './App.css';
import { Clipboard2CheckFill, ListColumns, PencilFill, X } from "react-bootstrap-icons";

const REMISION_UPDATE_API = HOST + '/api/inv/remision/update'
const REMISION_CANCEL_API = HOST + "/api/inv/remision/cancel/"

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT_SHORT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'long', day: '2-digit', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Remisiones() {
  const { userName, rol, token, comprasList, remisionPartidasList, remisionesList, getNombreEstado, setCallback, setGlobalLoading, formDataToJson, setMailBody, setMailTitle, setShowMesage, setPartidasList, dateForm, getRemisiones, getOrdenesCompra, getNombreProveedor, getNombreOrden } = useContext(GlobalContext);

  const [ show, setShow ] = useState(false)
  const [ showCancel, setShowCancel ] = useState(false)
  const [ showDetail, setShowDetail ] = useState(false)
  const [ action, setAction ] = useState('Crear Remisión')

  const [ remision, setRemision ] = useState({ idRemision: 0 })
  const [ idRemision, setIdRemision ] = useState()
  const [ idOrden, setIdOrden ] = useState()
  const [ idProveedor, setIdProveedor ] = useState()
  const [ fecha, setFecha ] = useState()
  const [ estatus, setEstatus ] = useState(true)
  const [ comentarios, setComentarios ] = useState(null)
  const [ usuarioRegistra, setUsuarioRegistra ] = useState(true)
  const [ fechaRegistra, setFechaRegistra ] = useState(true)
  const [ estatusDevolucion, setEstatusDevolucion ] = useState()
  const [ fechaAprobacion, setFechaAprobacion ] = useState(null)

  const [ showRemision, setShowRemision ] = useState(false)
  const [ showPrint, setShowPrint ] = useState(false)
  const [ proveedor, setProveedor ] = useState(null)
  const [ remisionOrden, setRemisionOrden ] = useState(null)
  const [ totalRequest, setTotalRequest ] = useState(0)
  const [ totalGet, setTotalGet ] = useState(0)
  const [ partidasRes, setPartidasRes ] = useState([])

  useEffect(() => {
    if(comprasList.length <= 0 )
      getOrdenesCompra()
    
    setGlobalLoading( true )
    setPartidasList([])
    getRemisiones()
  }, []);

  useEffect(() => {
    //console.log("remisionPartidas change", remisionPartidasList)
  }, [remisionPartidasList]);

  useEffect(() => {
    if(showPrint) {
      let temp = []

      temp.push(... remisionPartidasList)
      
      /*for( let j = 0; j < 15; j++ ){
        temp.push(... remisionPartidasList)
      }*/

      console.log("large list", temp)

      let numberOfList = 0
      let mainList = temp.splice( 0, 20 )
      let resultList = []
      
      if( temp.length > 20 ) {
        let rest = temp.length

        console.log("operations", rest, Math.ceil( rest / 30 ))
        numberOfList = Math.ceil( rest / 30 )
      }

      resultList[0] = mainList 
      console.log("numberOfList", numberOfList)

      for ( let i = 0; i < numberOfList; i++ ) {      
        resultList[ i + 1 ] = temp.splice( 0, 30 )
      }

      setPartidasRes( resultList )
      console.log("resultante list", resultList)
    }
  }, [ showPrint ]);

  const showForm = (item) => {

    if( item ){
      let date  = new Date(item.fecha)
      let dateP =  date.getFullYear() + "-" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "-" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate())

      setAction('Actualizar Remisión')
      setIdRemision(item.idRemision)
      setIdOrden(item.idOrden)
      setIdProveedor(item.idProveedor)
      setFecha(dateP)
      setEstatus(item.estatus)
      setUsuarioRegistra(item.usuarioRegistra)
      setFechaRegistra(item.fechaRegistra)
      setComentarios(item.comentarios)
      setEstatusDevolucion(item.estatusDevolucion)
      setFechaAprobacion(item.fechaAprobacion)
    } else {
      setAction('Nueva Remisión')
      setIdRemision(null)
      setIdOrden(null)
      setIdProveedor(null)
      setFecha(null)
      setEstatus(true)
      setUsuarioRegistra(userName)
      setFechaRegistra(null)
      setComentarios(null)
      setEstatusDevolucion('en_espera')
      setFechaAprobacion(null)
    }

    setShow(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    var form = document.getElementById('remisionForm');
		var formData = new FormData(form);
    formData.append('fecha', dateForm(fecha));
    
    var json = formDataToJson(formData)
    console.log('json to update orden de pago', json)

    axios.post(REMISION_UPDATE_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result remision update", result.data)
      getRemisiones()
      setShow(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const cancelRemision = () => {
    setGlobalLoading( true )

    axios.post(REMISION_CANCEL_API + remision.idRemision, {}, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result remove", result.data)
      getRemisiones()
      setShow(false)
      setGlobalLoading( false )
      setShowCancel(false)

      setShowMesage(true)
      setMailTitle('Cancelado')
      setMailBody(`La remisión ha sido cancelada.`)
      setCallback(false)

    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const onChangeOrden = (idOrden) => {
    let orden = comprasList.find(o => o.idOrden === parseInt(idOrden))

    if( orden ) { 
      setIdOrden( orden.idOrden )
      setIdProveedor( orden.idProveedor )
    }
  }

  const selectRemision = (item) => {
    setRemision(item)
    setShowDetail( true )
  }

  const confirmCancel = ( item ) => {
    selectRemision(item)
    setShowCancel(true)
  }

  const viewRemision = (item) => {
    setRemision(item)
    setRemisionOrden( getNombreOrden(item.idOrden) )
    setProveedor( getNombreProveedor(item.idProveedor) )
    setShowRemision(true)
  }

  const getRemision = () => {
    return (
      <>
        { remision && remision.idRemision > 0 && 
          <Container>
            <Row>
              <div>
                <Container>
                  <Row>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Proveedor </div>
                      <div>{ (remision.idProveedor).toString().padStart(4, '0') + ' - ' + getNombreProveedor(remision.idProveedor).razonSocial }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Fecha </div>
                      <div>{ DATE_FORMAT_SHORT.format((new Date( remision.fecha )).getTime()) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Creada por </div>
                      <div>{ remision.usuarioRegistra.toUpperCase() }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Total de piezas solicitadas </div>
                      <div>{ totalRequest }</div>
                    </Col>
                    { remisionPartidasList.length > 0 && 
                      <Col md="6" className='mb-3'>
                        <div className="desc-form"> Total de piezas recibidas </div>
                        <div>{ totalGet }</div>
                      </Col>
                    }
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Descuento de compra </div>
                      <div>{ CURRENCY_FORMAT.format( remision.descuento ) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Total de compra </div>
                      <div>{ CURRENCY_FORMAT.format( remision.total ) }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Condición de Pago </div>
                      <div>{ proveedor ? proveedor.diasVencimiento : '...' + ' días' }</div>
                    </Col>
        
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Comentarios </div>
                      <div>{ remision.comentarios }</div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Row>
            <Row>
              { remisionPartidasList.length > 0 && 
                <>
                  <div align="center">
                    <button type="button" className="grl-btn" onClick={ () => viewPrint(remision) } >{ 'Visualizar Remisión' }</button>&nbsp;&nbsp;
                  </div>
                  <div style={{ height: '20px' }}/>
                </>
              }
            </Row>
            <Row>
              { remisionPartidasList.length > 0 &&
                <>
                  <br/>
                  <div className="section-subtitle"> Detalle de la orden</div>
                  <br/>
                </>
              }
              <div>
                <RemisionPartidas readOnly={ true } remision={ remision }  remisionOrden={ remisionOrden } setRemisionOrden={ setRemisionOrden } setTotalRequest={ setTotalRequest } setTotalGet={ setTotalGet } />
              </div>
            </Row>
          </Container>
        }
      </>
    )
  }

  const viewPrint = () => {
    setShowPrint(true)
  }

  const printPDF = () => {
      setGlobalLoading( true )
      let pages = partidasRes.length
      let slide = 0
  
      const infoPageElement = document.getElementById("App");
      const pdf = new jsPDF('p', 'mm', 'a4');
  
      function htmlCanvas() {
        slide++
  
        if( slide >= pages ) {
          pdf.save(`OrdenCompra_${remisionOrden.idOrden}.pdf`);
          setGlobalLoading( false )
  
          return
        }
  
        pdf.addPage();
        const elem = document.getElementById("App_" + slide);
        console.log("element", slide, elem)
  
        html2canvas(elem, {
          scale:3,
          useCORS: true,
          allowTaint: false
        }).then(canvas => {
          pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288);
          console.log("image added")
          htmlCanvas()
        })
      }
  
      html2canvas(infoPageElement, {
        onclone: document => {},
        scale:3,
        useCORS: true,
        allowTaint: false
      }).then(canvas => {
  
        pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288, '', 'FAST');
        htmlCanvas()
      });
  
    };

    /**************************************** Data Table ****************************************/

    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);
  
    const columns = [
      {
        name: <th># Remisión</th>,
        selector: row => <div className="item-link" onClick={ () => showForm(row) }> 
          { `#${ (row.idRemision).toString().padStart(4, '0') }` }
        </div>,
        sortable: true,
      },
      {
        name: <th>Fecha</th>,
        selector: row => DATE_FORMAT_SHORT.format((new Date( row.fecha )).getTime()),
        sortable: true,
      },
      {
        name: <th># Orden</th>,
        selector: row => `#${ (row.idOrden).toString().padStart(4, '0') }`,
        sortable: true,
      },
      {
        name: <th>Proveedor</th>,
        selector: row => (row.idProveedor).toString().padStart(4, '0') + ' - ' + getNombreProveedor(row.idProveedor).razonSocial,
        sortable: true,
      },
      {
        cell: row => 
        <>
          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Resumen de la Remisión de Ingreso</Tooltip>}>
            <Clipboard2CheckFill onClick={ () => viewRemision(row) } className="table-icon" />
          </OverlayTrigger>
          { row.estatusDevolucion === 'en_espera' && 
            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Ver detalle</Tooltip>}>
              <ListColumns onClick={ () => selectRemision(row) } className="table-icon" />
            </OverlayTrigger>
          }
          { parseInt(rol) === 2  && row.estatus &&   
            <>
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar</Tooltip>}>
                <PencilFill onClick={ () => showForm(row) } className="table-icon" />
              </OverlayTrigger>
              { row.estatusDevolucion === 'en_espera' &&
                <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Remover</Tooltip>}>
                  <X onClick={ () => confirmCancel(row) } className="table-icon" />
                </OverlayTrigger>
              }
            </>
          }
        </>,
      },
    ];
  
    useEffect(() => {
      if( remisionesList.length > 0) {
        let data = []
  
        if(filterText && filterText !== '' ) {
          data = remisionesList.filter(
            item => item.titulo && item.titulo.toLowerCase().includes(filterText.toLowerCase()),
          )
        } else data = remisionesList
  
        setFilteredItems(data);
      }
    }, [ remisionesList, filterText ]);
  
    /**************************************** Data Table ****************************************/

  return (
    <>
      <Modal show={showCancel} onHide={ () => setShowCancel(false) }>
        <Modal.Header closeButton>
        <div className="title-form">{ `Cancelar orden #${remision.idRemision}` }</div>
        </Modal.Header>
        <Modal.Body>{ `¿Seguro que desea cancelar la remisión #${remision.idRemision}? Esta acción no se puede deshacer.` }</Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={ () => setShowCancel(false) } className="cancel-btn">{ 'Cerrar' }</button>&nbsp;&nbsp;
          <button type="button" onClick={ () => cancelRemision() } className="grl-btn">{ 'Cancelar' }</button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPrint} onHide={ () => setShowPrint(false) } size="xl">
        <Modal.Header closeButton>
          <div className="title-form">{ 'Previo - Remisión de Ingreso' }</div>
        </Modal.Header>
        <Modal.Body>
          { remisionOrden &&
          <>
          <div align="right"><button type="button" onClick={ () => printPDF() } className="grl-btn">{ 'Descargar' }</button></div>
          <br/>
          <div id="App" className="app-container">
            <div id="infoApp" className="app">
              { remision != null && remision.idRemision != 0 &&
                <Container>
                  <Row>
                    <Col md={ 6 }>
                      <div> <img src={ laJornada } className="print-logo" /> </div>
                      <br/>
                      <div className="section-subtitle"> DEMOS DESARROLLO DE MEDIOS </div>
                      <div> AV CUAUHTÉMOC 1236 SANTA CRUZ </div>
                      <div> ATOYAC ALCALDÍA BENITO JUÁREZ </div>
                      <div> RFC: <b>DDM840626PM</b> </div>
                    </Col>
                    <Col md={ 6 }>
                      <div style={{ textAlign: 'right' }}>
                        <div className="title-form" style={{ textAlign: 'right', fontSize: '45px' }}> Remisión de Compra </div>
                        <br/>
                        <div> <span>Fecha:</span> <b>{ DATE_FORMAT_SHORT.format((new Date( remisionOrden.fecha )).getTime()) }</b> </div>
                        <div> <span>Orden de compra:</span> <b>{ 'CON ' + remisionOrden.idOrden.toString().padStart(5, '0') }</b> </div>
                        <div> <span>Folio:</span> <b>{ 'REM ' + remision.idRemision.toString().padStart(5, '0') }</b> </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-5">
                    <Col md={ 6 }>
                      <div className="print-title"> PROVEEDOR </div> <br/>
                      { proveedor != null &&
                        <>
                          <div className="section-subtitle"> { proveedor.razonSocial } </div> <br/>
                          <div> { `${proveedor.calle} ${proveedor.numeroInt} ${proveedor.numeroExt}, ${proveedor.colonia}, ${getNombreEstado(proveedor.idEstado).estado}` } </div>
                          <div> RFC: <b>{proveedor.rfc}</b> </div> <br/>
                          
                          <div> Creado por: <b>{ remisionOrden.usuarioRegistra.toUpperCase() }</b> </div>
                          <div> Descuento: <b>{ remisionOrden.descuentoProv } %</b> </div>
                          <div> Impuestos: <b>{ proveedor.iva } %</b> </div>
                          <div> Plazo: <b>{ proveedor.diasVencimiento } días</b> </div>
                        </>
                      }
                    </Col>
                    <Col md={ 6 }>
                      <div id="resume">
                        <div className="print-title"> RESUMEN </div> <br/>
                        <Col md={ 12 }>
                          <div> Cantidad de piezas Solicitadas: <b>{ totalRequest } </b> </div>
                          <div> Cantidad de piezas Recibidas: <b>{ totalGet } </b> </div>
                          <br/>
                          <Table responsive>
                            <tbody>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> SUBTOTAL: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format(remision.subtotal) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> DESCUENTO: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format(remision.descuento) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> IVA: </div>
                                </td>
                                <td> 
                                  { CURRENCY_FORMAT.format(remision.impuestoRetenido) }
                                </td>
                              </tr>
                              <tr>
                                <td> 
                                  <div className="section-subtitle"> TOTAL: </div>
                                </td>
                                <td> 
                                  <b>{ CURRENCY_FORMAT.format(remision.total) }</b>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          <br/>
                          <div className="desc-form">{ NumeroALetras(remision.total) } M.N.
                          </div>
                          <div className="desc-form"> <b>Moneda:</b> MXN </div>
                        </Col>
                        <Col md={ 12 }>
                          <div className="print-title"> Comentarios </div> <br/>
                          <div>{ remision.comentarios }</div>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-5">
                    <Col md={ 12 } >
                      { partidasRes.length > 0 &&
                        <PartidasPrint partidasList={ partidasRes[0] } isRemision={ true } /> 
                      }
                    </Col>
                  </Row>
                </Container>
              }
            </div>
          </div>

          { partidasRes.length > 1 &&
            partidasRes.map((item, index) => {
              if( index !== 0 ) {
                return <>
                  <div id={ "App_" + index } className="app-container">
                    <div id={ "infoApp_" + index } className="app">
                      <Container>
                        <Row className="mt-5">
                          <Col md={ 12 } >
                            <PartidasPrint partidasList={ item } isRemision={ true } /> 
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </div>
                  <br/>
                </>
              }
            })
          }
          </>
        }
        </Modal.Body>
      </Modal>

      <Offcanvas show={showRemision} onHide={ () => setShowRemision(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ `Remision de Ingreso #${remision.idRemision.toString().padStart(5, '0')}` }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="remisionForm" onSubmit={ updateItem }>
            <input type="hidden" name='estatusDevolucion' value={ estatusDevolucion } />
            <input type="hidden" name='fechaAprobacion' value={ fechaAprobacion } />

            { getRemision() }
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="remisionForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idRemision" value={ idRemision } />
                  <input type="hidden" name="idProveedor" value={ idProveedor } />
                  <input type="hidden" name="usuarioRegistra" value={ usuarioRegistra } />
                  <input type="hidden" name="fechaRegistra" value={ fechaRegistra } />
                  <input type="hidden" name="estatus" value={ idRemision ? estatus : true } />
                  <input type="hidden" name="estatusDevolucion" value={ estatusDevolucion } />
                  <input type="hidden" name="fechaAprobacion" value={ fechaAprobacion } />
                  <Container>
                    <Row>
                      <Col md={12} className="pb-3">
                        <FloatingLabel label="Orden">
                          <Form.Select required name="idOrden" value={ idOrden } onChange={ (e) => onChangeOrden( e.target.value ) }>
                            <option>Selecciona una opción</option>
                            { comprasList.map( item => (
                              <option key={ item.idOrden } value={ item.idOrden }>{ `${item.idOrden} - ${getNombreProveedor(item.idProveedor).razonSocial}` }</option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col md={8}>
                        <FloatingLabel label="Proveedor">
                          <Form.Control required disabled value={ idProveedor ? getNombreProveedor(idProveedor).razonSocial : null } placeholder="" />
                        </FloatingLabel>
                      </Col>
                      <Col md={4}>
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Fecha">
                            <Form.Control required type="date" name="fecha" max={new Date().toISOString().split("T")[0]} value={ fecha } placeholder="" onChange={ (e) => setFecha( e.target.value ) }/>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <FloatingLabel label="Comentarios Generales">
                          <Form.Control required as="textarea" name="comentarios" rows={3} value={ comentarios } onChange={ (e) => setComentarios( e.target.value ) } placeholder="" />
                        </FloatingLabel>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showDetail} onHide={ () => { setShowDetail(false); setRemision({ idRemision: 0 }); setPartidasList([]); } } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form"> Detalle de Pedido </div>
            <div className="desc-form"> Administra los elementos a la remision especificando cantidad recibida. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div> { remision.idRemision > 0 ? <RemisionPartidas remision={ remision } setShowDetail={ setShowDetail } setTotalRequest={ setTotalRequest } setTotalGet={ setTotalGet } remisionOrden={ remisionOrden } setRemisionOrden={ setRemisionOrden }/> : <div>Selecciona una remisión para conocer su detalle.</div> } </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 9 }>
            <div className="section-subtitle"> Lista de Remisiones de Ingreso </div>
            <br/>
          </Col>
          <Col md={ 3 } align="right">
            { parseInt(rol) === 2 && <div className="single-btn" onClick={ () => showForm() } > Nuevo </div> }
          </Col>
        </Row>
        <Row>
          <Col>
            { filteredItems.length > 0 && 
              <>
                {/*<Form.Group className='mb-3'>
                  <FloatingLabel label="Buscar">
                    <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
                  </FloatingLabel>
                </Form.Group>*/}
              
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  persistTableHead
                />
              </>
            }
            { filteredItems.length === 0 && 
              <div>Sin registros</div>
            }
            {/*<Table responsive>
              <thead>
                <tr>
                  <th># Remisión</th>
                  <th>Fecha</th>
                  <th># Orden</th>
                  <th>Razon social</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                { remisionesList.length == 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { remisionesList.map( item => (
                  <tr key={ item.idRemision }>
                    <td> 
                      <div className="item-link" onClick={ () => showForm(item) }> 
                        { `#${ item.idRemision }` }
                      </div>
                    </td>
                    <td> 
                      { DATE_FORMAT_SHORT.format((new Date( item.fecha )).getTime()) } 
                    </td>
                    <td> 
                      { `#${item.idOrden}` } 
                    </td>
                    <td> 
                      { getNombreProveedor(item.idProveedor).razonSocial } 
                    </td>
                    <td align="right"> 
                      <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Ver detalle</Tooltip>}>
                        <EyeFill onClick={ () => selectRemision(item) } className="table-icon" />
                      </OverlayTrigger>
                      { parseInt(rol) === 2  && item.estatus &&   
                        <>
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar</Tooltip>}>
                            <PencilFill onClick={ () => showForm(item) } className="table-icon" />
                          </OverlayTrigger>
                          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Remover</Tooltip>}>
                            <X onClick={ () => confirmCancel(item) } className="table-icon" />
                          </OverlayTrigger>
                        </>
                      }
                    </td>
                  </tr>
                )) }
              </tbody>
            </Table>*/}
          </Col>
        </Row>
        {/*<Row>
          <Col md={ 12 } className="table-height">
            <div className="section-subtitle"> Detalle de la remisión</div>
            <br/>
            <div> { remision.idRemision > 0 ? <RemisionPartidas remision={ remision } /> : <div>Selecciona una remisión para conocer su detalle.</div> } </div>
          </Col>
        </Row>*/}
      </Container>

    </>
  );
}

export default Remisiones;